import { atom } from 'recoil';

export const AProjectConfigs = atom<{ [key: string]: any }>({
  key: 'projectConfigs',
  default: {},
});
